import cache from './cache';
import cloneSvg from './clone-svg';
var requestQueue = {};
export var queueRequest = function (url, callback) {
    var _a;
    (_a = requestQueue[url]) !== null && _a !== void 0 ? _a : (requestQueue[url] = []);
    requestQueue[url].push(callback);
};
export var processRequestQueue = function (url) {
    var callbacks = requestQueue[url];
    if (!callbacks) {
        return;
    }
    var _loop_1 = function (i, len) {
        setTimeout(function () {
            if (Array.isArray(requestQueue[url])) {
                var cacheValue = cache.get(url);
                var callback = callbacks[i];
                if (!callback) {
                    return;
                }
                if (cacheValue instanceof SVGSVGElement) {
                    callback(null, cloneSvg(cacheValue));
                }
                if (cacheValue instanceof Error) {
                    callback(cacheValue);
                }
                if (i === callbacks.length - 1) {
                    delete requestQueue[url];
                }
            }
        }, 0);
    };
    for (var i = 0, len = callbacks.length; i < len; i++) {
        _loop_1(i, len);
    }
};
//# sourceMappingURL=request-queue.js.map